/* =============================================
   BAMBOSO LANDING PAGE — JavaScript
   Clean Towels XL | bamboso.com
   ============================================= */

(function () {
  'use strict';

  /* ——————————————————————————————
     GALLERY — touch/mouse swipe
  —————————————————————————————— */
  function initGallery() {
    const track   = document.getElementById('bamGalleryTrack');
    const dots    = document.querySelectorAll('.bam-gallery__dot');
    const btnPrev = document.getElementById('bamGalleryPrev');
    const btnNext = document.getElementById('bamGalleryNext');
    if (!track) return;

    const slides = track.querySelectorAll('.bam-gallery__slide');
    const total  = slides.length;
    if (!total) return;

    let current  = 0;
    let startX   = 0;
    let isDragging = false;
    let dragDelta  = 0;

    function goTo(idx) {
      current = (idx + total) % total;
      track.style.transform = `translateX(-${current * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
    }

    // Dots
    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    // Arrows
    if (btnPrev) btnPrev.addEventListener('click', () => goTo(current - 1));
    if (btnNext) btnNext.addEventListener('click', () => goTo(current + 1));

    // Touch / mouse drag
    const viewport = track.parentElement;

    function onDragStart(x) {
      isDragging = true;
      startX = x;
      dragDelta = 0;
      track.style.transition = 'none';
    }

    function onDragMove(x) {
      if (!isDragging) return;
      dragDelta = x - startX;
      track.style.transform = `translateX(calc(-${current * 100}% + ${dragDelta}px))`;
    }

    function onDragEnd() {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = '';
      const threshold = viewport.offsetWidth * 0.2;
      if (dragDelta < -threshold) {
        goTo(current + 1);
      } else if (dragDelta > threshold) {
        goTo(current - 1);
      } else {
        goTo(current); // snap back
      }
    }

    // Touch events
    viewport.addEventListener('touchstart', e => onDragStart(e.touches[0].clientX), { passive: true });
    viewport.addEventListener('touchmove',  e => onDragMove(e.touches[0].clientX),  { passive: true });
    viewport.addEventListener('touchend',   onDragEnd);

    // Mouse events (desktop)
    viewport.addEventListener('mousedown',  e => { e.preventDefault(); onDragStart(e.clientX); });
    window  .addEventListener('mousemove',  e => { if (isDragging) onDragMove(e.clientX); });
    window  .addEventListener('mouseup',    onDragEnd);

    // Init first dot
    goTo(0);
  }

  /* ——————————————————————————————
     BUNDLE SELECTOR
  —————————————————————————————— */
  function initBundles() {
    const opts       = document.querySelectorAll('.bam-bundle-opt');
    const varInput   = document.getElementById('bamVariantId');
    const sellingPlanInput = document.getElementById('bamSellingPlan');
    const ctaText    = document.getElementById('bamCtaText');
    const stickyVar  = document.getElementById('bamStickyVariant');
    const stickyPrice= document.getElementById('bamStickyPrice');

    if (!opts.length) return;

    let isSubscription = true; // default: subscription tab is active

    // Unified alloc map (toallas or tiras — whichever the page published)
    const ALLOC = window.BAM_ALLOC_TOALLAS || window.BAM_ALLOC_TIRAS || null;
    const DEFAULT_PLAN = window.BAM_DEFAULT_PLAN_TOALLAS || window.BAM_DEFAULT_PLAN_TIRAS || null;

    function getCurrentPlanId() {
      if (sellingPlanInput && sellingPlanInput.value && !sellingPlanInput.disabled) {
        return sellingPlanInput.value;
      }
      return DEFAULT_PLAN;
    }

    // Returns subscription price in euros for a given variant using real Shopify allocation;
    // falls back to a 10% discount if allocation is not available (safety).
    function getSubPriceEuros(variantId, fallbackEuros) {
      const planId = getCurrentPlanId();
      if (ALLOC && planId && ALLOC[variantId] && ALLOC[variantId][planId] != null) {
        return ALLOC[variantId][planId] / 100;
      }
      return fallbackEuros * 0.90;
    }

    function formatMoney(cents) {
      const euros = cents / 100;
      return euros.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
    }

    function getDiscount(price, boxes) {
      // Savings vs 1-caja price-per-box
      const firstOpt = document.querySelector('.bam-bundle-opt[data-boxes="1"]');
      if (!firstOpt) return 0;
      const basePrice = parseFloat(firstOpt.dataset.price);
      const basePPB   = basePrice / 1;
      const thisPPB   = price / boxes;
      return Math.round((1 - thisPPB / basePPB) * 100);
    }

    function updatePrices() {
      opts.forEach((opt, i) => {
        const variantId = opt.dataset.variant;
        const rawPrice  = parseFloat(opt.dataset.price); // in euros (divided_by: 100.0 in Liquid)
        const rawCompare = parseFloat(opt.dataset.compare); // NaN if empty
        const boxes     = parseInt(opt.dataset.boxes, 10) || 1;
        const subPrice  = getSubPriceEuros(variantId, rawPrice);
        const activePrice = isSubscription ? subPrice : rawPrice;

        // Price element
        const priceEl = opt.querySelector('.bam-bundle-opt__price');
        if (priceEl) {
          priceEl.textContent = activePrice.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u20AC';
        }

        // Compare-at price element (strikethrough)
        const compareEl = opt.querySelector('.bam-bundle-opt__compare');
        if (compareEl) {
          if (!isNaN(rawCompare) && rawCompare > activePrice) {
            compareEl.textContent = rawCompare.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u20AC';
            compareEl.removeAttribute('hidden');
          } else {
            compareEl.setAttribute('hidden', '');
          }
        }

        // Per-box element (ids: bamPer0, bamPer1, bamPer2) [v2 free-shipping tag]
        const perId = ['bamPer0', 'bamPer1', 'bamPer2'][i];
        const perEl = document.getElementById(perId);
        if (perEl) {
          const ppb = (activePrice / boxes).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          // Preserve "+ Envío Gratis" span on bundles 2 cajas (i=1) and 3+1 (i=2)
          if (i === 0) {
            perEl.textContent = ppb + '\u20AC/caja';
          } else {
            perEl.innerHTML = ppb + '\u20AC/caja <span class="bam-bundle-shipping">+ Env&iacute;o Gratis</span>';
          }
        }

        // Savings badge (for bundles > 1 box)
        const saveId = ['bamSave1', 'bamSave2'][i - 1]; // Save1 = idx1, Save2 = idx2
        if (saveId) {
          const saveEl = document.getElementById(saveId);
          if (saveEl) {
            const firstOpt = document.querySelector('.bam-bundle-opt[data-boxes="1"]');
            if (firstOpt) {
              const baseUnit = parseFloat(firstOpt.dataset.price);
              const baseVar  = firstOpt.dataset.variant;
              const baseSub  = isSubscription ? getSubPriceEuros(baseVar, baseUnit) : baseUnit;
              const saving   = (baseSub * boxes) - activePrice;
              if (saving > 0) {
                saveEl.textContent = '-' + saving.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u20AC';
                saveEl.classList.add('is-visible');
              } else {
                saveEl.classList.remove('is-visible');
              }
            }
          }
        }
      });
    }

    function selectOpt(opt) {
      opts.forEach(o => o.classList.remove('is-selected'));
      opt.classList.add('is-selected');

      const variantId = opt.dataset.variant;
      const label     = opt.dataset.label || '';
      const rawPrice  = parseFloat(opt.dataset.price);
      const activePrice = isSubscription ? getSubPriceEuros(variantId, rawPrice) : rawPrice;

      // Update hidden form input
      if (varInput) varInput.value = variantId;

      // Update sticky bar
      if (stickyVar)   stickyVar.textContent   = label;
      if (stickyPrice) stickyPrice.textContent  = activePrice.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u20AC';
    }

    // Bundle click
    opts.forEach(opt => opt.addEventListener('click', () => {
      selectOpt(opt);
      updatePrices();
    }));

    // Default selection (is-selected already in HTML)
    const defaultOpt = document.querySelector('.bam-bundle-opt.is-selected') || opts[1] || opts[0];
    if (defaultOpt) selectOpt(defaultOpt);
    updatePrices();

    // Expose for toggle
    return { selectOpt, updatePrices, getIsSubscription: () => isSubscription, setSubscription: v => { isSubscription = v; } };
  }

  /* ——————————————————————————————
     SUBSCRIPTION TOGGLE
  —————————————————————————————— */
  function initToggle(bundleCtrl) {
    const btns            = document.querySelectorAll('.bam-type-btn');
    const freqWrap        = document.getElementById('bamFreqWrap');
    const sellingPlanInput= document.getElementById('bamSellingPlan');
    const DEFAULT_PLAN    = window.BAM_DEFAULT_PLAN_TOALLAS || window.BAM_DEFAULT_PLAN_TIRAS || '';

    if (!btns.length) return;

    // Remember the last selected plan id so we can restore it when toggling back to subscription
    let lastPlanId = sellingPlanInput ? (sellingPlanInput.value || DEFAULT_PLAN) : DEFAULT_PLAN;

    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        btns.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        const isSub = btn.dataset.mode === 'subscription';

        // Show/hide frequency
        if (freqWrap) freqWrap.classList.toggle('is-visible', isSub);

        // Enable/disable selling_plan input so it's only submitted when subscribing
        if (sellingPlanInput) {
          if (isSub) {
            sellingPlanInput.disabled = false;
            sellingPlanInput.value    = lastPlanId || DEFAULT_PLAN;
          } else {
            // Capture current value before disabling so we can restore it later
            if (sellingPlanInput.value) lastPlanId = sellingPlanInput.value;
            sellingPlanInput.disabled = true;
            sellingPlanInput.value    = '';
          }
        }

        // Update bundle state
        if (bundleCtrl) {
          bundleCtrl.setSubscription(isSub);
          bundleCtrl.updatePrices();
          const selected = document.querySelector('.bam-bundle-opt.is-selected');
          if (selected) bundleCtrl.selectOpt(selected);
        }
      });
    });
  }

  /* ——————————————————————————————
     CART FORM
  —————————————————————————————— */
  function initCart() {
    const form    = document.getElementById('bamboso-product-form') || document.querySelector('form[id^="bamboso"]');
    const ctaBtn  = document.getElementById('bamCtaBtn');
    const ctaText = document.getElementById('bamCtaText');

    if (!form) return;

    async function addToCart(e) {
      e.preventDefault();

      const variantId = document.getElementById('bamVariantId')?.value;
      if (!variantId || variantId === 'undefined' || variantId === '') {
        console.warn('Bamboso: No variant ID');
        form.submit(); // fallback
        return;
      }

      // Loading state
      if (ctaBtn)  ctaBtn.classList.add('is-loading');
      if (ctaText) ctaText.textContent = 'Añadiendo...';

      // Native Shopify Subscriptions: send `selling_plan` id when the customer chose a subscription
      const sellingPlanInput = document.getElementById('bamSellingPlan');
      const sellingPlanId = (sellingPlanInput && !sellingPlanInput.disabled && sellingPlanInput.value)
        ? sellingPlanInput.value
        : null;

      const cartBody = {
        id: parseInt(variantId, 10),
        quantity: 1
      };
      if (sellingPlanId) {
        cartBody.selling_plan = sellingPlanId;
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(cartBody)
        });

        if (!res.ok) throw new Error('cart/add failed');
        const addedItem = await res.json();

        // Success state
        if (ctaBtn)  { ctaBtn.classList.remove('is-loading'); ctaBtn.classList.add('is-success'); }
        if (ctaText) ctaText.textContent = '¡Añadido!';

        // Refresh cart drawer with updated content and open it
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          try {
            // Fetch fresh cart-drawer and cart-icon-bubble sections
            const [drawerHtml, bubbleHtml] = await Promise.all([
              fetch('/?section_id=cart-drawer').then(r => r.text()),
              fetch('/?section_id=cart-icon-bubble').then(r => r.text())
            ]);

            // Update drawer inner HTML
            const drawerDoc = new DOMParser().parseFromString(drawerHtml, 'text/html');
            const newDrawerInner = drawerDoc.querySelector('#CartDrawer');
            const currentDrawerInner = document.getElementById('CartDrawer');
            if (newDrawerInner && currentDrawerInner) {
              currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
            }

            // Update cart icon bubble
            const bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
            const newBubble = bubbleDoc.querySelector('#cart-icon-bubble');
            const currentBubble = document.getElementById('cart-icon-bubble');
            if (newBubble && currentBubble) {
              currentBubble.innerHTML = newBubble.innerHTML;
            }

            // Remove is-empty class if it was empty before
            drawer.classList.remove('is-empty');
            const innerEl = drawer.querySelector('.drawer__inner');
            if (innerEl) innerEl.classList.remove('is-empty');

            // Re-attach overlay listener
            const overlay = document.getElementById('CartDrawer-Overlay');
            if (overlay) overlay.addEventListener('click', () => drawer.close());

            // Re-init timer after innerHTML swap
            if (window.bamInitCartTimer) window.bamInitCartTimer();

            // Open drawer (no inline visibility — let CSS .drawer.active handle it)
            setTimeout(() => {
              if (window.bamOpenDrawer) {
                window.bamOpenDrawer();
              } else {
                drawer.classList.add('animate', 'active');
                document.body.classList.add('overflow-hidden');
              }
            }, 50);
          } catch(e) {
            console.warn('Drawer refresh failed, opening anyway', e);
            drawer.open();
          }
        } else {
          setTimeout(() => { window.location.href = '/cart'; }, 900);
        }

        setTimeout(() => {
          if (ctaBtn)  ctaBtn.classList.remove('is-success');
          if (ctaText) ctaText.textContent = 'Añadir al Carrito';
        }, 3000);

      } catch (err) {
        console.error('Bamboso cart error:', err);
        if (ctaBtn)  ctaBtn.classList.remove('is-loading');
        if (ctaText) ctaText.textContent = 'Añadir al Carrito';
        // Try opening the drawer anyway instead of redirecting to /cart
        if (window.bamOpenDrawer) {
          window.bamOpenDrawer();
        } else {
          const drawerFallback = document.querySelector('cart-drawer');
          if (drawerFallback) {
            drawerFallback.classList.add('animate', 'active');
            document.body.classList.add('overflow-hidden');
          }
        }
      }
    }

    form.addEventListener('submit', addToCart);

    // Also intercept click on the submit button directly (prevents native form submit race condition)
    const submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        addToCart(e);
      });
    }

    // Sticky CTA button delegates to addToCart directly
    const stickyCta = document.getElementById('bamStickyCta');
    if (stickyCta) {
      stickyCta.addEventListener('click', function(e) {
        e.preventDefault();
        addToCart(e);
      });
    }
  }

  /* ——————————————————————————————
     STICKY BAR — appear after hero
  —————————————————————————————— */
  function initSticky() {
    const sticky = document.getElementById('bamSticky');
    const cta    = document.getElementById('bamCtaBtn');
    if (!sticky || !cta) return;

    const observer = new IntersectionObserver(([entry]) => {
      // When main "Añadir al Carrito" is NOT visible -> show sticky
      sticky.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });

    observer.observe(cta);

    /* Tap on sticky body (NOT the CTA) scrolls up to bundles selector
       and reveals the site header so customer can pick a pack or open cart. */
    const body = sticky.querySelector('.bam-sticky__product') || sticky;
    body.addEventListener('click', function(e) {
      if (e.target.closest('.bam-sticky__cta')) return;
      const bundles = document.getElementById('bamBundles');
      const header = document.querySelector('sticky-header') || document.querySelector('.shopify-section-group-header-group');
      if (header && header.classList) {
        header.classList.remove('shopify-section-header-hidden');
        header.classList.add('shopify-section-header-sticky', 'animate');
      }
      if (bundles) {
        const y = bundles.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      }
    });
  }

  /* ——————————————————————————————
     CART DRAWER OPEN/CLOSE — hide sticky + page overlays while active
  —————————————————————————————— */
  function initDrawerHideSticky() {
    const drawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
    if (!drawer) return;
    const sync = () => {
      const open = drawer.classList.contains('active') || drawer.classList.contains('is-open');
      document.body.classList.toggle('bam-drawer-open', open);
    };
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  /* ——————————————————————————————
     FAQ ACCORDION
  —————————————————————————————— */
  function initFAQ() {
    document.querySelectorAll('.bam-faq-item').forEach(item => {
      const q = item.querySelector('.bam-faq-item__question');
      if (!q) return;
      q.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        document.querySelectorAll('.bam-faq-item').forEach(i => i.classList.remove('is-open'));
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  /* ——————————————————————————————
     SHOW MORE REVIEWS
  —————————————————————————————— */
  function initShowMore() {
    const moreBtn = document.querySelector('.bam-reviews__show-more-btn');
    const lessBtn = document.querySelector('.bam-reviews__show-less-btn');
    const grid    = document.getElementById('bam-reviews-grid');
    if (!moreBtn || !grid) return;
    const BATCH = 6;

    moreBtn.addEventListener('click', () => {
      const hidden = grid.querySelectorAll('.bam-reviews-hidden');
      if (!hidden.length) return;
      const batch = Array.from(hidden).slice(0, BATCH);
      batch.forEach((el, i) => {
        el.classList.remove('bam-reviews-hidden');
        el.style.animation = 'bamFadeIn 0.4s ease ' + (i * 0.06) + 's both';
      });
      // Show "ver menos" as soon as any extra reviews are visible
      if (lessBtn) lessBtn.style.display = 'inline-flex';
      // Hide "ver más" only when no more hidden cards remain
      const remaining = grid.querySelectorAll('.bam-reviews-hidden');
      if (!remaining.length) {
        moreBtn.style.display = 'none';
      }
    });

    if (lessBtn) {
      lessBtn.addEventListener('click', () => {
        const allCards = grid.querySelectorAll('.bam-review-card');
        allCards.forEach((card, i) => {
          if (i >= BATCH) {
            card.classList.add('bam-reviews-hidden');
            card.style.animation = '';
          }
        });
        lessBtn.style.display = 'none';
        moreBtn.style.display = 'inline-flex';
        // Scroll to reviews section
        const anchor = document.getElementById('bam-reviews-anchor');
        if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // Initial state: hide "ver menos" if there are hidden cards
    const hasHidden = grid.querySelectorAll('.bam-reviews-hidden').length > 0;
    if (hasHidden) {
      moreBtn.style.display = 'inline-flex';
      if (lessBtn) lessBtn.style.display = 'none';
    } else {
      moreBtn.style.display = 'none';
      if (lessBtn) lessBtn.style.display = 'none';
    }
  }

  /* ——————————————————————————————
     SCROLL ANIMATIONS
  —————————————————————————————— */
  function initAnimations() {
    if (!window.IntersectionObserver) return;
    const els = document.querySelectorAll('.bam-stat-card, .bam-step, .bam-review-card');
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.style.animation = 'bamFadeIn 0.5s ease forwards';
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(el => obs.observe(el));
  }

  /* ——————————————————————————————
     SCROLL-TO-BUNDLE links
  —————————————————————————————— */
  function initScrollLinks() {
    document.querySelectorAll('[data-action="scroll-to-bundle"]').forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault();
        const target = document.getElementById('bamBundles') || document.getElementById('bamboso-product-form');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  /* ——————————————————————————————
     CUSTOM FREQUENCY PICKER
  —————————————————————————————— */
  function initFreqPicker(bundleCtrl) {
    const btn              = document.getElementById('bamFreqBtn');
    const dropdown         = document.getElementById('bamFreqDropdown');
    const labelEl          = document.getElementById('bamFreqLabel');
    const sellingPlanInput = document.getElementById('bamSellingPlan');
    if (!btn || !dropdown) return;

    const chevron = btn.querySelector('.bam-freq-picker__chevron');

    function openDropdown() {
      dropdown.classList.add('is-open');
      if (chevron) chevron.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
    function closeDropdown() {
      dropdown.classList.remove('is-open');
      if (chevron) chevron.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }

    btn.addEventListener('click', e => {
      e.stopPropagation();
      dropdown.classList.contains('is-open') ? closeDropdown() : openDropdown();
    });

    dropdown.querySelectorAll('.bam-freq-opt').forEach(opt => {
      opt.addEventListener('click', e => {
        e.stopPropagation();
        const planId = opt.dataset.planId;
        if (labelEl) labelEl.textContent = opt.textContent.trim();
        if (sellingPlanInput && !sellingPlanInput.disabled && planId) {
          sellingPlanInput.value = planId;
        }
        dropdown.querySelectorAll('.bam-freq-opt').forEach(o => o.classList.remove('is-active'));
        opt.classList.add('is-active');
        closeDropdown();

        // Refresh displayed prices in case this plan has different allocation
        if (bundleCtrl) {
          bundleCtrl.updatePrices();
          const selected = document.querySelector('.bam-bundle-opt.is-selected');
          if (selected) bundleCtrl.selectOpt(selected);
        }
      });
    });

    document.addEventListener('click', closeDropdown);
  }

  /* ——————————————————————————————
     INIT
  —————————————————————————————— */
  function init() {
    initGallery();
    const bundleCtrl = initBundles();
    initToggle(bundleCtrl);
    initCart();
    initSticky();
    initDrawerHideSticky();
    initFAQ();
    initShowMore();
    initAnimations();
    initScrollLinks();
    initFreqPicker(bundleCtrl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
